import { CircularProgress, Stack, SxProps, Typography } from '@mui/material'
import { ReactNode } from 'react'

interface Props {
  text?: ReactNode
  sx?: SxProps
}

const LoaderIndicator = ({ text, sx }: Props) => {
  return (
    <Stack justifyContent="center" alignItems="center" spacing={2} sx={sx}>
      {text && <Typography>{text}</Typography>}
      <CircularProgress />
    </Stack>
  )
}

export default LoaderIndicator
